export function requestLocationPermission() {
  return Promise.resolve(true);
}
